export default __webpack_public_path__ + "static/media/FIU_SGA.4fbeb755.svg";